export default class Premium {
  constructor({
    active_plan = null,
    status = null,
    activated_at = null,
    expires_at = null,
    companies_count = 0,
    vacancies_count = 0,
    is_already_have_company = false,
    is_show_paywall_for_add_vacancy = false,
    is_show_paywall_for_add_company = false
  } = {}) {
    this.activePlan = active_plan;
    this.status = status;

    this.activatedAt =
      Premium.parseDate(activated_at);

    this.expiresAt =
      Premium.parseDate(expires_at);

    this.companiesCount =
      Number(companies_count) || 0;

    this.vacanciesCount =
      Number(vacancies_count) || 0;

    this.isAlreadyHaveCompany =
      is_already_have_company === true;

    /*
      Эти два значения вычисляет сервер.

      На клиенте повторно считать ограничения
      по тарифу, сроку действия и количеству
      компаний/вакансий больше не нужно.
    */
    this.isShowPaywallForAddVacancy =
      is_show_paywall_for_add_vacancy === true;

    this.isShowPaywallForAddCompany =
      is_show_paywall_for_add_company === true;
  }

  // MARK: - Mapping

  static fromJson(json = {}) {
    return new Premium(json);
  }

  // MARK: - Date

  static parseDate(value) {
    if (!value) {
      return null;
    }

    /*
      Если сервер когда-нибудь вернёт Date,
      повторно преобразовывать его не нужно.
    */
    if (value instanceof Date) {
      return Number.isNaN(value.getTime())
        ? null
        : value;
    }

    if (typeof value !== "string") {
      return null;
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      console.warn(
        "⚠️ Premium: некорректная дата:",
        value
      );

      return null;
    }

    return date;
  }

  // MARK: - Subscription

  get isActive() {
    if (
      this.status !== "active" ||
      !this.expiresAt
    ) {
      return false;
    }

    return this.expiresAt.getTime() > Date.now();
  }

  get planType() {
    return this.activePlan;
  }

  get isScout() {
    return (
      this.activePlan === "premium_scout"
    );
  }

  get isFullstackHR() {
    return (
      this.activePlan ===
      "premium_fullstack_hr"
    );
  }

  get hasKnownPlan() {
    return (
      this.isScout ||
      this.isFullstackHR
    );
  }

  // MARK: - Companies

  get hasNoCompanies() {
    return (
      !this.isAlreadyHaveCompany &&
      this.companiesCount < 1
    );
  }

  get hasCompany() {
    return (
      this.isAlreadyHaveCompany ||
      this.companiesCount > 0
    );
  }

  get hasMultipleCompanies() {
    return this.companiesCount > 1;
  }

  // MARK: - Server Paywall Flags

  get shouldShowVacancyPaywall() {
    return this.isShowPaywallForAddVacancy;
  }

  get shouldShowCompanyPaywall() {
    return this.isShowPaywallForAddCompany;
  }

  // MARK: - Actions

  canCreateVacancy() {
    /*
      Сначала проверяем наличие компании.
      Без неё вакансию создавать нельзя,
      но показывать premium paywall из-за
      этого не нужно.
    */
    if (this.hasNoCompanies) {
      return {
        allowed: false,
        reason: "no_company",
        showPaywall: false
      };
    }

    /*
      Решение о paywall уже принял сервер.
    */
    if (this.shouldShowVacancyPaywall) {
      return {
        allowed: false,
        reason: "paywall_required",
        showPaywall: true
      };
    }

    return {
      allowed: true,
      reason: null,
      showPaywall: false
    };
  }

  canCreateCompany() {
    /*
      Решение полностью берём с сервера.
    */
    if (this.shouldShowCompanyPaywall) {
      return {
        allowed: false,
        reason: "paywall_required",
        showPaywall: true
      };
    }

    return {
      allowed: true,
      reason: null,
      showPaywall: false
    };
  }

  // MARK: - Debug

  toJSON() {
    return {
      activePlan: this.activePlan,
      status: this.status,
      activatedAt: this.activatedAt,
      expiresAt: this.expiresAt,
      companiesCount: this.companiesCount,
      vacanciesCount: this.vacanciesCount,
      isAlreadyHaveCompany:
        this.isAlreadyHaveCompany,
      isShowPaywallForAddVacancy:
        this.isShowPaywallForAddVacancy,
      isShowPaywallForAddCompany:
        this.isShowPaywallForAddCompany,
      isActive: this.isActive
    };
  }
}